import * as React from 'react';

import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import { SlatePlugin } from '../../slatePlugins/slatePlugins.types';
import {
  EXERCISE_QUIZ,
  EditorExerciseOptions,
} from './types';

const QuizElement = dynamicEditorComponent(() =>
  import('./components/QuizElement').then((mod) => mod.QuizElement)
);
const renderElementEditorExerciseQuiz = (options: EditorExerciseOptions) => (props) => {
  const { progressList } = options;
  const { element } = props;
  if (EXERCISE_QUIZ === element?.type) {
    const startFromOrder = element?.startFrom;
    const quizData = progressList.find(progress => element?.id === progress?.exerciseId);

    return (
      <QuizElement
        {...props}
        {...options}
        lastUserAnswers={quizData?.userAnswers}
        startFromOrder={startFromOrder}
      />
    );
  }
};

export const EditorExerciseQuizPlugin = (
  options?: EditorExerciseOptions,
): SlatePlugin => {
  return {
    renderElement: renderElementEditorExerciseQuiz(options),
  };
};
